<template>

<svg  xmlns="http://www.w3.org/2000/svg" 
	  viewBox="-11.5 780.5 24 24" >
<path d="M4.771,797.647v-4.659c0-0.008-0.001-0.017-0.002-0.024c0-0.002,0-0.004,0-0.006c-0.001-0.013-0.004-0.026-0.009-0.039
	c-0.001-0.003-0.002-0.007-0.003-0.01c-0.005-0.014-0.01-0.026-0.017-0.039l0,0l0,0c-0.007-0.012-0.015-0.022-0.024-0.033
	c-0.002-0.003-0.004-0.006-0.007-0.009c-0.009-0.01-0.019-0.019-0.029-0.027c-0.001-0.001-0.003-0.002-0.005-0.003
	c-0.007-0.005-0.013-0.01-0.02-0.014l-4.035-2.329c-0.073-0.042-0.163-0.042-0.235,0l-4.035,2.329
	c-0.007,0.004-0.014,0.009-0.02,0.014c-0.001,0.001-0.003,0.002-0.005,0.003c-0.011,0.009-0.02,0.018-0.029,0.027
	c-0.002,0.003-0.005,0.006-0.007,0.009c-0.009,0.01-0.017,0.021-0.024,0.033l0,0l0,0c-0.007,0.013-0.013,0.025-0.018,0.039
	c-0.001,0.003-0.002,0.007-0.003,0.01c-0.004,0.013-0.007,0.025-0.009,0.039c0,0.002,0,0.004,0,0.006
	c0,0.008-0.001,0.017-0.001,0.024v4.659c0,0.084,0.045,0.162,0.118,0.204l4.035,2.33c0.007,0.004,0.015,0.007,0.022,0.011
	c0.001,0.001,0.003,0.002,0.005,0.003c0.013,0.005,0.025,0.009,0.038,0.012c0.003,0,0.007,0.001,0.01,0.002
	c0.014,0.002,0.028,0.004,0.042,0.004c0.014,0,0.028-0.002,0.042-0.004c0.004-0.001,0.007-0.002,0.01-0.002
	c0.013-0.003,0.026-0.007,0.039-0.012c0.002-0.001,0.003-0.002,0.005-0.003c0.007-0.004,0.015-0.007,0.022-0.011l4.035-2.33
	C4.726,797.81,4.771,797.732,4.771,797.647z"/>
<path d="M-1.077,800.752l-3.917-2.262v-4.523c0-0.106-0.071-0.2-0.174-0.228s-0.211,0.018-0.265,0.109l-4.035,6.989
	c-0.042,0.073-0.042,0.163,0,0.235c0.042,0.073,0.12,0.118,0.204,0.118h8.07c0.106,0,0.2-0.072,0.228-0.175
	C-0.939,800.914-0.984,800.806-1.077,800.752z"/>
<path d="M-3.417,791.235l3.917-2.262l3.917,2.263c0.037,0.021,0.078,0.031,0.118,0.031c0.061,0,0.121-0.023,0.167-0.069
	c0.075-0.075,0.091-0.191,0.038-0.283l-4.035-6.989c-0.042-0.073-0.12-0.118-0.204-0.118c-0.084,0-0.162,0.045-0.204,0.118
	l-4.035,6.988c-0.054,0.093-0.038,0.209,0.037,0.284S-3.51,791.289-3.417,791.235z"/>
<path d="M10.469,800.838l-4.035-6.988c-0.054-0.093-0.162-0.138-0.265-0.11c-0.103,0.028-0.175,0.121-0.175,0.228v4.523
	l-3.917,2.262c-0.092,0.054-0.137,0.162-0.109,0.265c0.027,0.104,0.121,0.175,0.227,0.175h8.07c0.084,0,0.162-0.045,0.204-0.117
	C10.511,801.001,10.511,800.911,10.469,800.838z"/>
</svg>

</template>